import React, { Component } from 'react';
import { isSaleOpportunityValid } from './opportunityValidation';
import {
  Container,
  Row, Col, Input, Button, Form, FormGroup, Label, Modal, ModalHeader, ModalBody, ModalFooter, Table,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt, faNoteSticky } from '@fortawesome/free-solid-svg-icons'
import Autocomplete from '../Autocomplete/Autocomplete';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import CollapseCard from '../../components/CollapseCard/CollapseCard';
import OpportunitiesNotesForm from './demographicsForm/OpportunitiesNotesForm';
import { CSVLink } from "react-csv";
import CompanyContext from '../../auth/CompanyContext';
import ConfirmButton from '../Modal/ConfirmButton';
class SalesOpportunities extends Component {
  static contextType = CompanyContext;

  constructor(props) {
    super(props);
    this.reactTable = React.createRef();

    this.defaultCheckboxes = {
      // statusFilterInactive: { checked: false, statuses: [98] },
      // statusFilterDead: { checked: false, statuses: [98, 99] },
      // statusFilterMaintenance: { checked: false, statuses: [11, 12, 13, 14, 15] },
      // statusFilterInternal: { checked: false, statuses: [20, 21, 22, 23, 30, 31, 32, 33, 40, 41, 50, 51, 52, 53, 60, 61, 62, 63] },
      // statusFilterRecurring: { checked: true, statuses: [10] },
      // statusFilterSalesPipe: { checked: true, statuses: [0, 1, 2, 3, 4] },
      // statusFilterInProgress: { checked: true, statuses: [5, 6, 7, 8, 9, 16] },
    };

    this.state = {
      notesCategories: [],
      addCategoryCommentsArray: [],
      showInactive: localStorage.getItem('salesOpportunitiesShowInactive') ? localStorage.getItem('salesOpportunitiesShowInactive') === 'true'
        : false,
      // checkboxes: localStorage.getItem(`salesOpportunitiesCheckboxes${this.props.type}`) ? JSON.parse(localStorage.getItem(`salesOpportunitiesCheckboxes${this.props.type}`))
      //   : JSON.parse(JSON.stringify(this.defaultCheckboxes)),
      expanded: {},
      tableReady: false,
      showModal: false,
      selectedOpportunity: null
    }

    this.reportColumns = [
      {
        expander: true,
        show: false
      },
      {
        Header: 'WA#',
        accessor: 'WA#',
        filterable: true,
        width: 95,
        Cell: row => <>{row.value || `WA${row.original.ID}`}</>
      },
      {
        Header: this.props.type,
        accessor: `Sales Opportunity Name`,
        filterable: true,
        Cell: row =>
        (<><Link
          onClick={(e) => {
            e.stopPropagation();
            localStorage.setItem('demographicsActiveTab', 3);
          }}
          to={{ pathname: '/demographics/' + row.original['SEC#'], state: {} }}>{row.original['Sales Opportunity Name']}</Link> {!row.original['Active'] && <span className="commentTag">Inactive</span>}</>)
      },
      {
        Header: 'Date',
        accessor: 'Sales Opportunity Date',
        filterable: true,
        Cell: (props) => {
          return <>{this.formatDate(props.value)}</>
        }
      },
      {
        Header: 'Last Updated',
        accessor: 'Timestamp',
        filterable: true,
        Cell: (props) => {
          return <>{this.formatDateTime(props.value)}</>
        }
      },
      {
        Header: 'Amount',
        accessor: 'Opportunity Amount',
        filterable: true,
        Cell: (props) => {
          return <>{props.value != null ? '$' + Intl.NumberFormat().format(props.value) : ''}</>
        }
      },
      {
        Header: 'Company',
        accessor: 'Primary Business Name',
        filterable: true,
        Cell: row =>
        (<Link
          onClick={(e) => e.stopPropagation()}
          to={{ pathname: '/demographics/' + row.original['SEC#'], state: {} }}
        >{row.original['Primary Business Name']}</Link>)
      },
      {
        Header: 'Contact',
        accessor: 'Contact Name',
        filterable: true,
        Cell: (props) => {
          return <>{props.value} {!props.original['Contact Active'] && props.original['Contact Active'] != null ? ' (Inactive)' : ''}</>
        }
      },
      {
        Header: 'Type',
        accessor: 'Type',
        filterable: true,
      },
      {
        Header: 'Status',
        accessor: 'Status',
        filterable: true,
      },
      {
        Header: 'Stage',
        accessor: 'Stage',
        filterable: true,
      },
      {
        Header: 'Source',
        accessor: 'Source',
        filterable: true,
      },
      {
        id: 'Opportunity Sales Rep User',
        Header: 'Sales Rep',
        accessor: d => { return d['Opportunity Sales Rep User First Name'] != null ? (d['Opportunity Sales Rep User First Name'] + ' ' + d['Opportunity Sales Rep User Last Name']) : '' },
        filterable: true,
      },
      {
        id: 'Opportunity Assignee User',
        Header: 'Assignee',
        accessor: d => { return d['Opportunity Assignee User First Name'] != null ? (d['Opportunity Assignee User First Name'] + ' ' + d['Opportunity Assignee User Last Name']) : '' },
        filterable: true,
      },
      {
        Header: 'Next Steps',
        accessor: 'Next Steps',
        filterable: true,
      },
      {
        Header: 'ID',
        accessor: 'ID',
        filterable: false,
        Cell: (props) => {
          const date = this.formatDateMMDDYY(props.original['Sales Opportunity Date'])
          return <>{date}-{props.original['ID']}-{this.props.type === 'Sale' ? 'S' : 'O'}</>
        }
      },
      {
        Header: 'Notes',
        accessor: 'NewNotes',
        filterable: false,
        Cell: (props) => {
          return <>{props.original['NewNotes'] && props.original['NewNotes'].length > 0 ?
            <Button
              size="sm"
              color="dark"
              outline
              onClick={() => this.showModal(props.original['ID'])}
              className='font-weight-bold'
            ><FontAwesomeIcon icon={faNoteSticky} /> ({props.original['NewNotes'].length})</Button>
            : ''}</>
        }
      },
    ]
  }

  componentDidMount = () => {
    this.getNotesCategories();
    setTimeout(() => {
      this.setState({ tableReady: true });
    }, 300);
  }

  showModal = (val) => {
    const selectedOpportunity = this.props.opportunities.find(opportunity => opportunity.ID === val) || null;
    if (!selectedOpportunity) return;
    this.setState(prevState => {
      return {
        showModal: !prevState.showModal,
        selectedOpportunity: selectedOpportunity
      }
    }, () => {

    })
  }

  openEditor = (rowInfo) => {
    this.props.onEdit(rowInfo.original.ID)
    this.setState({
      expanded: { [rowInfo.viewIndex]: true },
      selectedOpportunity: rowInfo.original
    });
  };

  closeEditor = () => {
    this.setState({ expanded: {} });
  };

  formatDate = (d) => {
    if (!d) return '';
    if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
    return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
  }

  formatDateTime = (date) => {
    if (!date) return null;
    if (!(date instanceof Date)) {
      date = new Date(date);
      if (isNaN(date.getTime())) return date;
    }
    const utcMonth = date.getUTCMonth() + 1; // Months are zero-based
    const utcDay = date.getUTCDate();
    const utcYear = date.getUTCFullYear();
    const utcHours = date.getUTCHours();
    const utcMinutes = date.getUTCMinutes();

    // Format time to am/pm
    const period = utcHours >= 12 ? "PM" : "AM";
    const formattedHours = utcHours % 12 || 12; // Convert to 12-hour format
    const formattedMinutes = utcMinutes.toString().padStart(2, "0");

    const formattedDate = `${utcMonth}/${utcDay}/${utcYear} ${formattedHours}:${formattedMinutes} ${period}`;
    return formattedDate;
  }

  formatDateMMDDYY = (date) => {
    if (!date) return null;

    if (!(date instanceof Date)) {
      date = new Date(date);
      if (isNaN(date.getTime())) return date;
    }

    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = String(date.getUTCFullYear()).slice(-2);

    return `${month}${day}${year}`;
  };

  filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    const content = row[id];
    if (typeof content !== 'undefined') {
      // filter by text in the table or if it's a object, filter by key
      if (typeof content === 'object' && content !== null && content.key) {
        return String(content.key).toLowerCase().includes(filter.value.toLowerCase());
      } else {
        return String(content).toLowerCase().includes(filter.value.toLowerCase());
      }
    }
    return true;
  };

  onSelectAutocomplete = (val, edit, cb) => {
    this.props.onChange({
      persist: () => null,
      target: {
        name: 'sec',
        value: val.sec
      }
    }, (edit ? "edit" : null), cb)
    this.props.onChange({
      persist: () => null,
      target: {
        name: 'primaryBusinessName',
        value: val.name
      }
    }, (edit ? "edit" : null), cb)
    this.props.getContacts(val.sec, edit)
  }

  // standardRow = (opportunity) => {
  //   return (
  //     <tr className="adminRow pointer text-left" onClick={() => this.props.onEdit(opportunity.ID)}>
  //       <td>{opportunity['Sales Opportunity Name']}</td>
  //       <td>{this.formatDate(opportunity['Sales Opportunity Date'])}</td>
  //       <td className='text-right'>{opportunity['Opportunity Amount'] != null ? '$' + Intl.NumberFormat().format(opportunity['Opportunity Amount']) : ''}</td>
  //       <td>{opportunity['Primary Business Name']}</td>
  //       <td>{opportunity['Contact Name']}{!opportunity['Contact Active'] ? ' (Inactive)' : ''}</td>
  //       <td>{opportunity.Type}</td>
  //       <td>{opportunity.Status}</td>
  //       <td>{opportunity.Stage}</td>
  //       <td>{opportunity['Opportunity Sales Rep User First Name']} {opportunity['Opportunity Sales Rep User Last Name']}</td>
  //       <td>{opportunity['Opportunity Assignee User First Name']} {opportunity['Opportunity Assignee User Last Name']}</td>
  //       <td>{opportunity['Next Steps']}</td>
  //     </tr>
  //   )
  // }

  editRow = (opportunity) => {
    const timeout = 1000;
    const showHistory = false;
    return (<div className="editRow adminRow">
      {/* <td colSpan={8}> */}
      <Row>
        <Col md={9}>
          <Row>
            <Col md={9} className="text-left">
              <Form inline>
                <FormGroup className="mr-2 mb-2">
                  <Autocomplete {...this.props}
                    clientToken={this.props.clientToken}
                    available_dates={this.props.available_dates}
                    newPage={false}
                    timeout={timeout}
                    showHistory={showHistory}
                    placeholder="Company"
                    onSelect={(val, cb) => this.onSelectAutocomplete(val, true, cb)}
                    value={this.props.editOpportunity.primaryBusinessName}
                    showContacts={false}
                    handleCallback={(cb) => this.props.handleCallback(cb)}
                    cb={() => {
                      if (this.props.editOpportunity != null && this.props.editOpportunity.primaryBusinessName !== '') {
                        this.props.onChange({
                          persist: () => null,
                          target: {
                            name: 'primaryBusinessName',
                            value: ''
                          }
                        }, "edit")
                        this.props.onChange({
                          persist: () => null,
                          target: {
                            name: 'contactLinkedID',
                            value: ''
                          }
                        }, "edit")
                        this.props.onChange({
                          persist: () => null,
                          target: {
                            name: 'contacts',
                            value: []
                          }
                        }, "edit")
                      }
                    }}
                    edit={true}
                  />
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    placeholder="Invalid Company"
                    name="sec"
                    disabled={true}
                    value={this.props.editOpportunity.sec + ''}
                    className={this.props.editOpportunity.sec !== '' ? "is-valid" : "is-invalid"}
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  {this.props.editOpportunity.contacts != null && this.props.editOpportunity.contacts.length > 0 &&
                    <Input
                      type="select"
                      name="contactLinkedID"
                      onChange={e => this.props.onChange(e, 'edit')}
                      value={this.props.editOpportunity.contactLinkedID}
                    >
                      <option value="">Contact</option>
                      {this.props.editOpportunity.primaryBusinessName !== '' && this.props.editOpportunity.contacts.map(contact => {
                        if (contact.children != null && contact.children['Contact Name'] != null) {
                          return (<option key={contact.linkedID} value={contact.linkedID}>
                            {contact.children['Contact Name']}
                            {!contact.active ? ' (Inactive)' : ''}
                          </option>)
                        } else {
                          return null;
                        }
                      })}
                    </Input>}
                </FormGroup>
              </Form>
            </Col>
            <Col md={3} className="text-right">
              <Button
                className="mx-1"
                color="success"
                onClick={() => {
                  this.props.handleEdit();
                  this.setState({ expanded: {} }); // Collapse all rows
                }}
                title="Edit Opportunity"
                disabled={!isSaleOpportunityValid(this.props.editOpportunity, { requireCompany: true })}
              >
                <FontAwesomeIcon icon={faCheck} />
              </Button>
              <ConfirmButton className="mx-3" color="danger" onClick={(e) => { this.props.onDelete(opportunity.ID); }} edit="Delete Opportunity">
                <FontAwesomeIcon icon={faTrashAlt} />
              </ConfirmButton>
              <Button className="mx-1" color="secondary"
                onClick={() => {
                  this.setState({ expanded: {} }); // Collapse all rows
                  this.props.handleCancel();
                }}
                title="Cancel"
              >
                <FontAwesomeIcon icon={faTimes} />
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form inline>
                <FormGroup className="mr-2 mb-2">
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>WA</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      aria-label="WA number"
                      placeholder="Number"
                      name="waNumber"
                      maxLength={100}
                      value={this.props.editOpportunity.waNumber + ''}
                      onChange={e => this.props.onChange(e, 'edit')}
                    />
                  </InputGroup>
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    placeholder={`${this.props.type} Name`}
                    name="name"
                    value={this.props.editOpportunity.name + ''}
                    onChange={e => this.props.onChange(e, 'edit')} />
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    type="date"
                    name="date"
                    value={String(this.props.editOpportunity.date).substring(0, 10) + ''}
                    onChange={e => this.props.onChange(e, 'edit')} />
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    type="select"
                    name="typeID"
                    value={this.props.editOpportunity.typeID}
                    onChange={e => this.props.onChange(e, 'edit')}>
                    <option value={0}>Type</option>
                    {this.props.types.map(type => (
                      <option key={type.ID} value={type.ID}>{type.Opportunity}</option>
                    ))}
                  </Input>
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    type="select"
                    name="statusID"
                    value={this.props.editOpportunity.statusID}
                    onChange={e => this.props.onChange(e, 'edit')}>
                    <option value={0}>Status</option>
                    {(this.props.selectedStatuses || this.props.statuses).map(status => (
                      <option key={status.ID} value={status.ID}>{status.Opportunity}</option>
                    ))}
                  </Input>
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    type="select"
                    name="stageID"
                    value={this.props.editOpportunity.stageID}
                    onChange={e => this.props.onChange(e, 'edit')}>
                    <option value={0}>Stage</option>
                    {this.props.stages.map(stage => (
                      <option key={stage.ID} value={stage.ID}>{stage.Opportunity}</option>
                    ))}
                  </Input>
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input type="select" name="sourceID" value={this.props.editOpportunity.sourceID || 0} onChange={e => this.props.onChange(e, 'edit')}>
                    <option value={0}>Source</option>
                    {this.props.sources.map(source => <option key={source.ID} value={source.ID}>{source.Opportunity}</option>)}
                  </Input>
                </FormGroup>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form inline>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    type="select"
                    name="assigneeUserID"
                    value={this.props.editOpportunity.assigneeUserID}
                    onChange={e => this.props.onChange(e, 'edit')}>
                    <option value={0}>Assignee</option>
                    {this.props.users.map(user => (
                      <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                    ))}
                  </Input>
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    placeholder="Assignee (Other)"
                    name="assigneeUserOther"
                    value={this.props.editOpportunity.assigneeUserOther + ''}
                    onChange={e => this.props.onChange(e, 'edit')} />
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    type="select"
                    name="salesRepUserID"
                    value={this.props.editOpportunity.salesRepUserID}
                    onChange={e => this.props.onChange(e, 'edit')}>
                    <option value={0}>Sales Rep</option>
                    {this.props.users.map(user => (
                      <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                    ))}
                  </Input>
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    placeholder="Sales Rep (Other)"
                    name="salesRepUserOther"
                    value={this.props.editOpportunity.salesRepUserOther + ''}
                    onChange={e => this.props.onChange(e, 'edit')} />
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Input
                    placeholder={`${this.props.type} Amount`}
                    name="opportunityAmount"
                    value={this.props.editOpportunity.opportunityAmount != null ? this.props.editOpportunity.opportunityAmount : ''}
                    onChange={e => this.props.onChange(e, 'edit')} />
                </FormGroup>
                <FormGroup className="mr-2 mb-2">
                  <Label><Input
                    placeholder="Active"
                    type="checkbox"
                    name="active"
                    checked={this.props.editOpportunity.active}
                    onChange={e => this.props.onChange(e, 'edit')} />Active</Label>
                </FormGroup>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup className="mr-2 mb-2">
                <Input
                  type="select"
                  name="maintenanceRequirementStatus"
                  value={this.props.editOpportunity.maintenanceRequirementStatus}
                  onChange={e => this.props.onChange(e, 'edit')}>
                  <option value="">Maint. Requirement Status</option>
                  <option>Maint - Optional</option>
                  <option>Maint - Mandatory</option>
                  <option>Maint - Not Offered</option>
                </Input>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mr-2 mb-2">
                <Input
                  type="select"
                  name="maintenanceAcceptanceStatus"
                  value={this.props.editOpportunity.maintenanceAcceptanceStatus}
                  onChange={e => this.props.onChange(e, 'edit')}>
                  <option value="">Maint. Acceptance Status</option>
                  <option>Maint - N/A</option>
                  <option>Maint - Offered</option>
                  <option>Maint - Accepted</option>
                  <option>Maint - Declined</option>
                </Input>
              </FormGroup>
            </Col>
            <Col>
              <FormGroup className="mr-2 mb-2">
                <Input
                  type="date"
                  name="maintenanceEndDate"
                  value={this.props.editOpportunity.maintenanceEndDate != null ? this.props.editOpportunity.maintenanceEndDate : ''}
                  onChange={e => this.props.onChange(e, 'edit')}>
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row className='mb-2'>
            <Col>
              <Input
                placeholder='Maintenance Notes'
                type="textarea"
                rows={6}
                name="maintenanceNotes"
                value={this.props.editOpportunity.maintenanceNotes + ''}
                onChange={e => this.props.onChange(e, 'edit')}
              />
            </Col>
          </Row>
          <Row className='mb-2'>
            <Col>
              <Input
                placeholder='Notes'
                type="textarea"
                rows={6}
                name="notes"
                value={this.props.editOpportunity.notes + ''}
                onChange={e => this.props.onChange(e, 'edit')}
              />
            </Col>
          </Row>
          <Row className='mb-2'>
            <Col>
              <Input
                placeholder='Next Steps'
                name="nextSteps"
                value={this.props.editOpportunity.nextSteps + ''}
                onChange={e => this.props.onChange(e, 'edit')}
              />
            </Col>
          </Row>
        </Col>
        <Col className='border-left border-dark text-left'>
          <OpportunitiesNotesForm
            addCategoryCommentsArray={this.state.addCategoryCommentsArray}
            displayCategories={this.displayCategories}
            getSalesOpportunities={this.props.getSalesOpportunities}
            via="SalesOpportunities"
            {...this.props} />
        </Col>
      </Row>

      {/* </td> */}
    </div>
    )
  }

  addRow = () => {
    const timeout = 1000;
    const showHistory = false;
    return (
      <>
        <Row className='pt-4 text-left align-items-bottom'>
          <Col md={9}>
            <Form inline>
              <FormGroup className="mr-2 mb-2">
                <Autocomplete {...this.props}
                  clientToken={this.props.clientToken}
                  available_dates={this.props.available_dates}
                  newPage={false}
                  timeout={timeout}
                  showHistory={showHistory}
                  placeholder="Company"
                  onSelect={(val, cb) => this.onSelectAutocomplete(val, false, cb)}
                  value={this.props.newOpportunity.primaryBusinessName}
                  edit={false}
                  showContacts={false}
                  handleCallback={(cb) => this.props.handleCallback(cb)}
                />
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  placeholder="Invalid Company"
                  name="sec"
                  disabled={true}
                  value={this.props.newOpportunity.sec + ''}
                  className={this.props.newOpportunity.sec !== '' ? "is-valid" : "is-invalid"}
                />
              </FormGroup>
              <FormGroup className="mb-2">
                {this.props.newOpportunity.contacts.length > 0 && <Input
                  type="select"
                  name="contactLinkedID"
                  onChange={e => this.props.onChange(e)}
                  value={this.props.newOpportunity.contactLinkedID}
                >
                  <option value="">Contact</option>
                  {this.props.newOpportunity.primaryBusinessName !== '' && this.props.newOpportunity.contacts.map(contact => {
                    if (contact.children != null && contact.children['Contact Name'] != null) {
                      return (<option key={contact.linkedID} value={contact.linkedID}>
                        {contact.children['Contact Name']}
                        {!contact.active ? ' (Inactive)' : ''}
                      </option>)
                    } else {
                      return null;
                    }
                  })}
                </Input>}
              </FormGroup>
            </Form>
          </Col>
          <Col md={3} className="text-right">
            {JSON.stringify(this.props.newOpportunity) !== JSON.stringify(this.props.blankOpportunity) && <Button
              // disabled={JSON.stringify(this.props.newOpportunity) === JSON.stringify(this.props.blankOpportunity)}
              color="secondary"
              onClick={this.props.handleCancelAdd}
              className="mr-2"
            >
              Reset
            </Button>}
            <Button
              disabled={!isSaleOpportunityValid(this.props.newOpportunity, { requireCompany: true })}
              color="primary"
              onClick={this.props.handleAdd}>
              Add {this.props.type}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form inline>
              <FormGroup className="mr-2 mb-2">
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>WA</InputGroupText>
                  </InputGroupAddon>
                  <Input
                    aria-label="WA number"
                    placeholder="Number"
                    name="waNumber"
                    maxLength={100}
                    value={this.props.newOpportunity.waNumber + ''}
                    onChange={e => this.props.onChange(e)}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  placeholder={`${this.props.type} Name`}
                  name="name"
                  value={this.props.newOpportunity.name + ''}
                  onChange={e => this.props.onChange(e)} />
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  type="date"
                  name="date"
                  value={String(this.props.newOpportunity.date).substring(0, 10) + ''}
                  onChange={e => this.props.onChange(e)} />
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  type="select"
                  name="typeID"
                  value={this.props.newOpportunity.typeID}
                  onChange={e => this.props.onChange(e)}>
                  <option value={0}>Type</option>
                  {this.props.types.map(type => (
                    <option key={type.ID} value={type.ID}>{type.Opportunity}</option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  type="select"
                  name="statusID"
                  value={this.props.newOpportunity.statusID}
                  onChange={e => this.props.onChange(e)}>
                  <option value={0}>Status</option>
                  {this.props.statuses.filter(status => status.Tag.findIndex(tag => tag === this.props.type) > -1).map(status => (
                    <option key={status.ID} value={status.ID}>{status.Opportunity}</option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  type="select"
                  name="stageID"
                  value={this.props.newOpportunity.stageID}
                  onChange={e => this.props.onChange(e)}>
                  <option value={0}>Stage</option>
                  {this.props.stages.map(stage => (
                    <option key={stage.ID} value={stage.ID}>{stage.Opportunity}</option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input type="select" name="sourceID" value={this.props.newOpportunity.sourceID || 0} onChange={e => this.props.onChange(e)}>
                  <option value={0}>Source</option>
                  {this.props.sources.map(source => <option key={source.ID} value={source.ID}>{source.Opportunity}</option>)}
                </Input>
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form inline>
              <FormGroup className="mr-2 mb-2">
                <Input
                  type="select"
                  name="assigneeUserID"
                  value={this.props.newOpportunity.assigneeUserID}
                  onChange={e => this.props.onChange(e)}>
                  <option value={0}>Assignee</option>
                  {this.props.users.map(user => (
                    <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  placeholder="Assignee (Other)"
                  name="assigneeUserOther"
                  value={this.props.newOpportunity.assigneeUserOther + ''}
                  onChange={e => this.props.onChange(e)} />
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  type="select"
                  name="salesRepUserID"
                  value={this.props.newOpportunity.salesRepUserID}
                  onChange={e => this.props.onChange(e)}>
                  <option value={0}>Sales Rep</option>
                  {this.props.users.map(user => (
                    <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                  ))}
                </Input>
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  placeholder="Sales Rep (Other)"
                  name="salesRepUserOther"
                  value={this.props.newOpportunity.salesRepUserOther + ''}
                  onChange={e => this.props.onChange(e)} />
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Input
                  placeholder={`${this.props.type} Amount`}
                  name="opportunityAmount"
                  value={this.props.newOpportunity.opportunityAmount + ''}
                  onChange={e => this.props.onChange(e)} />
              </FormGroup>
              <FormGroup className="mr-2 mb-2">
                <Label><Input
                  placeholder="Active"
                  type="checkbox"
                  name="active"
                  checked={this.props.newOpportunity.active}
                  onChange={e => this.props.onChange(e)} />Active</Label>
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup className="mr-2 mb-2">
              <Input
                type="select"
                name="maintenanceRequirementStatus"
                value={this.props.newOpportunity.maintenanceRequirementStatus}
                onChange={e => this.props.onChange(e)}>
                <option value="">Maint. Requirement Status</option>
                <option>Maint - Optional</option>
                <option>Maint - Mandatory</option>
                <option>Maint - Not Offered</option>
              </Input>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup className="mr-2 mb-2">
              <Input
                type="select"
                name="maintenanceAcceptanceStatus"
                value={this.props.newOpportunity.maintenanceAcceptanceStatus}
                onChange={e => this.props.onChange(e)}>
                <option value="">Maint. Acceptance Status</option>
                <option>Maint - N/A</option>
                <option>Maint - Offered</option>
                <option>Maint - Accepted</option>
                <option>Maint - Declined</option>
              </Input>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup className="mr-2 mb-2">
              <Input
                type="date"
                name="maintenanceEndDate"
                value={this.props.newOpportunity.maintenanceEndDate}
                onChange={e => this.props.onChange(e)}>
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <Row className='mb-2'>
          <Col>
            <Input
              placeholder='Maintenance Notes'
              type="textarea"
              rows={6}
              name="maintenanceNotes"
              value={this.props.newOpportunity.maintenanceNotes}
              onChange={e => this.props.onChange(e)}
            />
          </Col>
        </Row>
        {/* <Row className='mb-2'>
          <Col>
            <Input
              placeholder='Notes'
              type="textarea"
              rows={6}
              name="notes"
              value={this.props.newOpportunity.notes}
              onChange={e => this.props.onChange(e)}
            />
          </Col>
        </Row> */}
        <Row className='mb-2'>
          <Col>
            <Input
              placeholder='Next Steps'
              name="nextSteps"
              value={this.props.newOpportunity.nextSteps}
              onChange={e => this.props.onChange(e)}
            />
          </Col>
        </Row>
      </>
    )
  }

  getNotesCategories() {
    // console.log('SalesOpportunities.js/getUsers()');
    fetch('/api/notesCategories/', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.props.clientToken,
        'X-Database': this.context.company
      }
    })
      .then(results => results.json())
      .then(results => {
        this.setState((prevState, props) => {

          let data = results.data;
          let debug_message = results.debug_message;

          let return_value = {
            notesCategories: {
              loading: false,
              data: data,
              'debug_message': debug_message,
            }
          };
          return return_value;
        });
      });
    return;
  }

  displayCategories = (e) => {
    const categoryList = typeof (this.state.notesCategories.data.filter(
      item => parseInt(item.ID) === parseInt(e.target.value)
    )[0]) !== 'undefined' ? this.state.notesCategories.data.filter(
      item => parseInt(item.ID) === parseInt(e.target.value)
    )[0].children : [];
    categoryList.forEach((item) => { item.value = null; })
    const categoryValue = parseInt(e.target.value);
    this.setState((prevState, props) => {
      let return_value = {
        selectValue: categoryValue,
        addCategoryCommentsArray: categoryList
      }
      return return_value;
    });
  };

  onChangeFilter = (e) => {
    e.persist();
    this.setState((prevState) => {
      let obj = { ...prevState };
      obj.checkboxes[e.target.name].checked = !prevState.checkboxes[e.target.name].checked;
      return obj;
    }, () => localStorage.setItem(`salesOpportunitiesCheckboxes${this.props.type}`, JSON.stringify(this.state.checkboxes)))
  };

  setStatusFilter = (opportunities) => {
    // return opportunities;
    if (!this.props.defaultCheckboxes) return [];
    if (this.props.defaultCheckboxes && Object.entries(this.props.defaultCheckboxes).length > 0 && !this.state.checkboxes) {
      this.setState({
        checkboxes: { ...this.props.defaultCheckboxes }
      })
    }
    if (!this.state.checkboxes) return [];
    const checkedEntries = Object.entries(this.state.checkboxes).filter(([_, v]) => v.checked);
    // console.log('ce',checkedEntries)
    if (checkedEntries.length === 0) {
      return opportunities;
    }

    const visibleStatuses = checkedEntries.flatMap(([_, v]) => v.statuses);

    return opportunities.filter(item => {
      const statusCode = parseInt(item?.['Opportunity Status ID']);
      return visibleStatuses.includes(statusCode);
    });
  };

  getExportData = () => {
    const raw = this.setStatusFilter(this.props.opportunities).filter(item => this.state.showInactive !== item.Active);
    // Reapply filters manually
    let filtered = raw;
    const storedFilters = localStorage.getItem('salesOpportunitiesFiltered');
    if (storedFilters) {
      const filters = JSON.parse(storedFilters);
      filters.forEach(filter => {
        const { id, value } = filter;

        const column = this.reportColumns.find(col => col.id === id || col.accessor === id);
        if (!column) return;

        const getValue = typeof column.accessor === 'function'
          ? column.accessor
          : (row) => row[column.accessor];

        filtered = filtered.filter(row => {
          const content = getValue(row);
          if (!content) return false;
          return String(content).toLowerCase().includes(value.toLowerCase());
        });
      });
    }

    // Reapply sorting manually
    const storedSorted = localStorage.getItem('salesOpportunitiesSorted');
    if (storedSorted) {
      const sorted = JSON.parse(storedSorted);
      sorted.forEach(({ id, desc }) => {
        // Find the matching column definition to get the correct accessor
        const col = this.reportColumns.find(col => col.accessor === id || col.id === id);
        if (!col) return;

        const getValue = typeof col.accessor === 'function'
          ? col.accessor
          : (row) => row?.[col.accessor] ?? '';

        filtered = filtered.sort((a, b) => {
          const aVal = getValue(a);
          const bVal = getValue(b);

          // Normalize to strings and handle nulls gracefully
          const aStr = (aVal != null ? String(aVal) : '').toLowerCase();
          const bStr = (bVal != null ? String(bVal) : '').toLowerCase();

          if (aStr < bStr) return desc ? 1 : -1;
          if (aStr > bStr) return desc ? -1 : 1;
          return 0;
        });
      });
    }
    // this.props.setOpportunityCount(filtered?.length);

    return filtered.map(row => [
      `${row['Sales Opportunity Name']}${!row['Active'] ? ' (Inactive)' : ''}`,
      row['WA#'] || `WA${row.ID}`,
      this.formatDate(row['Sales Opportunity Date'] || ''),
      this.formatDate(row['Timestamp'] || ''),
      row['Opportunity Amount'] ? new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(row['Opportunity Amount']) : '',
      row['Primary Business Name'],
      `${row['Contact Name']} ${!row['Contact Active'] && row['Contact Active'] != null ? ' (Inactive)' : ''}`,
      row['Type Description'],
      row['Status'],
      row['Stage'],
      `${row['Opportunity Sales Rep User First Name'] ? `${row['Opportunity Sales Rep User First Name']} ${row['Opportunity Sales Rep User Last Name']}` : ''}`,
      row['Opportunity Assignee User Other'] || `${row['Opportunity Assignee User First Name'] || ''} ${row['Opportunity Assignee User Last Name'] || ''}`,
      row['Next Steps'],
      row['MaintenanceRequirementStatus'],
      row['MaintenanceAcceptanceStatus'],
      this.formatDate(row['MaintenanceEndDate'] || ''),
      row['MaintenanceNotes'],
      row['MaintenanceNextSteps'],
      row['CommissionNotes']
    ]);
  };

  render() {
    const reactTableData = this.setStatusFilter(this.props.opportunities).filter(item => this.state.showInactive !== item.Active);
    return (
      <Container className="adminContainer" fluid>
        <Modal isOpen={this.state.showModal} size="xl">
          {this.state.selectedOpportunity != null && <>
            <ModalHeader toggle={() => this.setState({ showModal: false })}>
              Notes: {this.state.selectedOpportunity['Sales Opportunity Name']} ({this.state.selectedOpportunity['WA#'] || `WA${this.state.selectedOpportunity.ID}`}) ({this.state.selectedOpportunity['Primary Business Name']})
            </ModalHeader>
            {/* CampaignNew  */}
            <ModalBody>
              <Table>
                <thead>
                  <tr>
                    <th width="15%">Date</th>
                    {/* <th width="20%">Submitted by</th> */}
                    <th width="15%">Type</th>
                    <th>Note</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.selectedOpportunity?.NewNotes?.map(note => {
                    const rawText = note.notes; // `From: Diane Herrera <dherrera@cssisolutions.com>\nSent: Wednesday, March 19, 2025 2:57 PM\nTo: Mike Herrera <mherrera@cssisolutions.com>\n\nI did that already.`;
                    const lines = rawText.split("\n");
                    return (
                      <tr key={note.id}>
                        <td>{this.formatDate(note.date)}
                          <br /><Label>{note.firstName} {note.lastName}</Label>
                        </td>
                        <td>{note.type}</td>
                        <td>{lines.map((line, i) => (
                          <React.Fragment key={i}>
                            {line}
                            <br />
                          </React.Fragment>
                        ))}</td>
                      </tr>
                    )
                  }
                  )}
                </tbody>
              </Table>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => this.setState({ showModal: false })}
              >
                Close
              </Button>
            </ModalFooter>
          </>}
        </Modal >
        <CollapseCard title={`${this.props.type} Entries (${reactTableData.length})`} open={true}>
          <Row className='mb-1'>
            <Col>
              <CollapseCard title={`Add ${this.props.type}`} open={false} header="h4">
                {this.addRow()}
              </CollapseCard>
            </Col>
          </Row>
          <Row className="mb-5 mt-5">
            <Col>
              <Form inline>
                {this.props.salesTypes.length > 0 && this.state.checkboxes && Object.entries(this.state.checkboxes)?.length > 0 && this.props.salesTypes.map((salesType, salesTypeIndex) => (
                  <FormGroup key={salesTypeIndex} className='mx-4'>
                    <Label style={{ fontSize: '16px' }}>
                      <Input
                        type="checkbox"
                        name={`statusFilter${salesType.Tag.replace(/[^a-zA-Z0-9]/g, "")}`}
                        checked={this.state.checkboxes[`statusFilter${salesType.Tag.replace(/[^a-zA-Z0-9]/g, "")}`]?.checked}
                        onChange={this.onChangeFilter} />
                      {salesType.Tag}
                    </Label>
                  </FormGroup>
                ))}
              </Form>
            </Col>
            <Col md={2} className='text-right'>
              <Label><Input
                type="checkbox"
                name="showInactive"
                checked={this.state.showInactive}
                onChange={() => this.setState({ showInactive: !this.state.showInactive }, () => localStorage.setItem('salesOpportunitiesShowInactive', this.state.showInactive))}
              />Toggle Inactive</Label>

            </Col>
            <Col md={2} className="text-right">
              <Button
                color="secondary"
                className="mr-2"
                onClick={() => {
                  localStorage.removeItem('salesOpportunitiesFiltered')
                  localStorage.removeItem('salesOpportunitiesSorted')
                  localStorage.removeItem('salesOpportunitiesCheckboxes')
                  this.reactTable.current.setState((prevState) => {
                    let obj = prevState;
                    obj.filtered = [];
                    obj.sorted = [];
                    return obj;
                  });
                  this.setState({
                    showInactive: false,
                    // checkboxes: JSON.parse(JSON.stringify(this.defaultCheckboxes))
                  })
                }}
              >
                Reset
              </Button>
              <CSVLink
                className="btn btn-primary"
                filename="Sales Opportunities Export.csv"
                headers={[
                  `${this.props.type} Name`,
                  'WA#',
                  'Date',
                  'Last Updated',
                  'Amount',
                  'Company',
                  'Contact Name',
                  'Type',
                  'Status',
                  'Stage',
                  'Sales Rep',
                  'Assignee',
                  'Next Steps',
                  'Maint. Requirement Status',
                  'Maint. Acceptance Status',
                  'Maint. End Date',
                  'Maint. Notes',
                  'Maint. Next Steps',
                  'Commission Notes'
                ]}
                data={this.getExportData()}
              >Export CSV</CSVLink>
            </Col>
          </Row>
          <Row>
            <Col>
              {reactTableData.length > 0 ?
                <ReactTable
                  data={reactTableData}
                  columns={this.reportColumns}
                  pageSize={this.props.opportunities.length}
                  showPagination={false}
                  defaultFilterMethod={this.filterCaseInsensitive}
                  ref={this.reactTable}
                  // keep your localStorage handlers:
                  onFilteredChange={(filtered) => {
                    localStorage.setItem('salesOpportunitiesFiltered', JSON.stringify(filtered));
                    this.setState({ tableReady: true });
                  }}
                  onSortedChange={(sorted) => {
                    localStorage.setItem('salesOpportunitiesSorted', JSON.stringify(sorted));
                    this.setState({ tableReady: true });
                  }}
                  defaultFiltered={localStorage.getItem('salesOpportunitiesFiltered') ? JSON.parse(localStorage.getItem('salesOpportunitiesFiltered')) : []}
                  defaultSorted={localStorage.getItem('salesOpportunitiesSorted') ? JSON.parse(localStorage.getItem('salesOpportunitiesSorted')) : []}

                  // NEW: control expansion and row "replacement"
                  expanded={this.state.expanded}
                  onExpandedChange={(expanded) => this.setState({ expanded })}

                  getTrProps={(state, rowInfo) => {
                    if (!rowInfo) return {};
                    const isEditing = !!this.state.expanded[rowInfo.viewIndex];
                    return {
                      onClick: (e) => {
                        if (e.target.closest('a, button, input')) return;
                        this.openEditor(rowInfo)
                      },
                      style: isEditing ? { display: 'none' } : undefined, // hide original row when expanded
                      className: isEditing ? 'row-hidden' : 'row-normal',
                    };
                  }}

                  // render your editor full-width as the “replacement”
                  SubComponent={(row) => (
                    <div className="p-3">
                      {this.editRow(row.original)}
                      <div className="text-right mt-2">
                        <Button size="sm" color="secondary" onClick={this.closeEditor}>Close Editor</Button>
                      </div>
                    </div>
                  )}
                />
                : <h3>Loading...</h3>}
            </Col>
          </Row>
        </CollapseCard>
      </Container>
    );
  }
}

export default SalesOpportunities;
